// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23YTG","option":"styles_option__24I5T","selected":"styles_selected__1ozxm"};